<template>
  <div class="row">
    <div class="form-group col-md-12">
      <div class="card">
        <div class="card-header">
          <span>{{ $t('investmentOpportunity.form.comments') }}</span>
          
          <div class="float-right" >
            <a href="#comments" name="action" @click="addComment"  v-if="compMode != CRUDMODE.READ">
              <span class="fa fa-plus fa-lg"></span>
            </a>
            &nbsp;
            <a href="#section" name="section" v-on:click="expandOrCollapse">
              <span class="fa fa-expand fa-lg" v-if="!localVisible" ></span>
              <span class="fa fa-compress fa-lg" v-if="localVisible"></span>
            </a>
          </div>
        </div>
        <div class="card-body" v-if="localVisible">
          <div class="row">

            <table id="dataTableAction" width="100%" cellspacing="0" 
                class="table table-bordered table-striped dataTable" >
             <thead>
                <tr>
                  <th width="300">{{ $t('investmentOpportunity.form.stage') }}</th>
                  <th>{{ $t('member.form.action.comment') }}</th>
                  <th>{{ $t('investmentOpportunity.form.user') }}</th>
                  <th width="50" v-if="compMode != CRUDMODE.READ"></th>
                </tr>
              </thead>
              <tfoot>
                <tr>
                <th width="300">{{ $t('investmentOpportunity.form.stage') }}</th>
                  <th>{{ $t('member.form.action.comment') }}</th>
                     <th>{{ $t('investmentOpportunity.form.user') }}</th>
                  <th width="50" v-if="compMode != CRUDMODE.READ"></th>
                </tr>
              </tfoot>
              <tbody>
                <tr class="odd" v-if="comments == null || comments.length == 0">
                    <td valign="top" colspan="4" class="dataTables_empty">Aucune donnée disponible dans le tableau</td>
                </tr>

                <tr v-for="(item, index) in comments" v-bind:data-id="item.id" :key="item.id">
                  
                  <td>
                    <select v-model="item.stage"
                        v-validate="'required'" class="form-control" :placeholder="$t('investmentOpportunity.form.stage')">
                        <option v-for="s in stages" :value="s.key" :key="s.key">{{s.value}}</option>
                    </select>
                    <span class="text-danger" v-if="errors.has('reason'+ index)">{{ $t('validations.required') }}</span>
                  </td>
                  <td>
                      <textarea v-model.trim="item.comment"  class="form-control" name="comment" :placeholder="$t('member.form.action.comment')" ></textarea>
                  </td>
                  <td style="width: 15%"><span>{{ userAndDate(item) }}</span></td>
                  <td align="center" v-if="compMode != CRUDMODE.READ">
                    <a  class="text-danger" v-bind:title="$t('form.delete_button')" href="#entrepreneur" v-on:click="removeAction(index)">
                        <span class="fa fa-lg fa-trash"></span>
                    </a>
                  </td> 
                </tr>
              </tbody>
            </table>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {InvestmentOpportunityServiceClient, InvestmentOpportunityCommentDto} from '../../shared/service-clients/service-clients'
  import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
  import CrudMixin from '../../shared/Mixin/CrudMixin'
  import MomentDatePicker from '../../shared/components/MomentDatePicker'
  import store from '../../store'
  export default {
    name: 'InvestmentOpportunityComments',
    props: {
      comments: {},
    },
    data() {
      return {
        stages: {},
        localVisible: true,
      }
    },
    mixins: [CrudMixin],
    mounted: function() {
      let self = this
      setTimeout(function() {
        self.fetchData()
        self.setMode()
      }, 1000)
    },
    methods: {
      userAndDate: function(commentDto) {
        if (commentDto.id != null) {
          return `Créé le ${commentDto.creationTime.format('DD/MM/YYYY')} par ${commentDto.user.fullName}`
        }
      },
      expandOrCollapse: function() {
        this.localVisible = !this.localVisible
      },
      fetchData: function() {
        let investmentOpportunityService = ServiceFactory.create(InvestmentOpportunityServiceClient)
        let getStages = investmentOpportunityService.getStages()
        let self = this
        getStages
          .then(res => {
            self.stages = res
          })
          .catch(err => {
            err
          })
      },
      addComment: function() {
        let dto = new InvestmentOpportunityCommentDto()
        dto.init({})
        dto.userId = this.$store.state.currentUser.id

        this.comments.push(dto)
      },
      removeAction: function(index) {
        this.comments.splice(index, 1)
      },
    },
    components: {
      'moment-date-picker': MomentDatePicker,
    },
  }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
</style>



// WEBPACK FOOTER //
// src/components/InvestmentOpportunity/InvestmentOpportunityComments.vue